export type AppRole = "all" | "superadmin";

export type LauncherApp = {
  id: string;
  name: string;
  description: string;
  icon: string;
  /** Accent color used for the tile icon badge. */
  accent: string;
  role: AppRole;
};

/**
 * Static registry of Oceany apps shown in the launcher.
 * Actual navigation URLs are resolved at runtime via getAppUrls() (see config.ts),
 * so nothing here is hardcoded to a specific environment.
 */
export const LAUNCHER_APPS: LauncherApp[] = [
  {
    id: "seas",
    name: "Seas",
    description: "Spazi di lavoro condivisi",
    icon: "🌊",
    accent: "#0ea5e9",
    role: "all",
  },
  {
    id: "wave",
    name: "Wave",
    description: "Documenti collaborativi",
    icon: "📝",
    accent: "#6366f1",
    role: "all",
  },
  {
    id: "tide",
    name: "Tide",
    description: "Note e form",
    icon: "🗒️",
    accent: "#14b8a6",
    role: "all",
  },
  {
    id: "surf",
    name: "Surf",
    description: "Presentazioni AI",
    icon: "🎞️",
    accent: "#f59e0b",
    role: "all",
  },
  {
    id: "compass",
    name: "Compass",
    description: "Task e attività",
    icon: "🧭",
    accent: "#ec4899",
    role: "all",
  },
  {
    id: "pulse",
    name: "Pulse",
    description: "Reel e video",
    icon: "📱",
    accent: "#ef4444",
    role: "all",
  },
  {
    id: "reef",
    name: "Reef",
    description: "Feed articoli e newsletter",
    icon: "🪸",
    accent: "#0ea5e9",
    role: "all",
  },
  {
    id: "currents",
    name: "Currents",
    description: "Config agenti",
    icon: "⚙️",
    accent: "#8b5cf6",
    role: "superadmin",
  },
  {
    id: "admin",
    name: "Vida Admin",
    description: "Amministrazione piattaforma",
    icon: "🛡️",
    accent: "#64748b",
    role: "superadmin",
  },
];
